// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/SuitcaseTheatreArcadeStyle.css';
import lukeImage from "../static/images/SuitcaseTheatreArcadeLogo.jpg";

function Home() {


    return (
        <div className="home-outer-container">
            <div className="home-marquee fade-in">
                <p>Interactive Street Theatre and Arts Education</p>
                <h1>The Suitcase<br/>Theatre Arcade</h1>
                <span>Zone in on Miniature Worlds!</span>
            </div>
            <div className="home-container fade-in">

                <div className="home-image-container home-item">
                    <img className="home-image" src= {lukeImage} alt={"Suitcase Theatre Arcade"}/>
                </div>
                <div className="home-text-container">
                    <p className="home-status">Now playing</p>
                    <h2>Zone in on miniature worlds.</h2>
                    <p>
                        Portable puppet shows and hands-on arts experiences for
                        events, schools, libraries and community spaces.
                    </p>
                    <div className="home-actions">
                        <Link className="arcade-button arcade-button-primary" to="/services">
                            Explore services
                        </Link>
                        <Link className="arcade-button arcade-button-secondary" to="/EventList">
                            View events
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
